function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["children", "className", "PaperProps", "width"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { cloneElement } from 'react';
import { node, number, object, oneOf, oneOfType, string } from 'prop-types';
import clsx from 'clsx';
import { useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import { findChildByType, filterOutChildrenByType } from '../internals/utils/reactHelpers';
import SovosDialogActions from '../sovos-dialog-actions';
import SovosDialogContent from '../sovos-dialog-content';
import SovosDialogTitle from '../sovos-dialog-title';
var SMALL = 'small';
var MEDIUM = 'medium';
var LARGE = 'large';
var getWidthStyle = function getWidthStyle(width, spacing) {
  if (width === SMALL) {
    return {
      maxWidth: spacing(50)
    };
  }
  if (width === MEDIUM) {
    return {
      minWidth: spacing(75),
      maxWidth: spacing(87.5)
    };
  }
  if (width === LARGE) {
    return {
      minWidth: spacing(75),
      maxWidth: '80vw',
      width: '80vw'
    };
  }
  return {
    width: width
  };
};

/**
 * Dialogs can use the `SovosDialogTitle`, `SovosDialogContents`, and
 * `SovosDialogActions` components for styling and positioning their contents.
 */
var SovosDialog = function SovosDialog(_ref) {
  var children = _ref.children,
    className = _ref.className,
    PaperProps = _ref.PaperProps,
    width = _ref.width,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTheme = useTheme(),
    spacing = _useTheme.spacing;
  var title = findChildByType(children, SovosDialogTitle);
  var content = findChildByType(children, SovosDialogContent) || /*#__PURE__*/React.createElement(SovosDialogContent, null, filterOutChildrenByType(children, SovosDialogTitle, SovosDialogActions));
  var actions = findChildByType(children, SovosDialogActions);
  var renderTitle = function renderTitle() {
    var _title$props$onClose, _title$props;
    var handleClose = (_title$props$onClose = title === null || title === void 0 ? void 0 : (_title$props = title.props) === null || _title$props === void 0 ? void 0 : _title$props.onClose) !== null && _title$props$onClose !== void 0 ? _title$props$onClose : rest.onClose;
    return title ? /*#__PURE__*/cloneElement(title, {
      onClose: handleClose !== null && handleClose !== void 0 ? handleClose : null
    }) : null;
  };
  return /*#__PURE__*/React.createElement(Dialog, _extends({
    className: clsx('sovosDialog', className),
    PaperProps: _objectSpread({
      style: _objectSpread({}, PaperProps.style),
      sx: _objectSpread({
        borderRadius: 'shape.borderRadius',
        padding: spacing(3)
      }, getWidthStyle(width, spacing))
    }, PaperProps)
  }, rest), renderTitle(), content, actions);
};
SovosDialog.propTypes = {
  /**
   * The content of the dialog. Should be wrapped with `SovosDialogTitle`,
   * `SovosDialogContent`, and `SovosDialogActions`
   */
  children: node.isRequired,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Props passed the MuiDialog paper component
   */
  PaperProps: object,
  /**
   * Width, can be 'small', 'medium', 'large' or an arbitrary number.
   *
   * - `small`: maxWidth: '400px'
   * - `medium`: minWidth: '600px', maxWidth: '700px'
   * - `large`: width: '80%', minWidth: '600px',
   */
  width: oneOfType([oneOf([SMALL, MEDIUM, LARGE]), number])
};
SovosDialog.defaultProps = {
  className: undefined,
  PaperProps: {},
  width: MEDIUM
};
SovosDialog.baseComponent = {
  name: 'Dialog',
  link: 'dialog/'
};
export default SovosDialog;